import { render, staticRenderFns } from "./DisplaySubMenu2.vue?vue&type=template&id=f1fc769a&scoped=true&"
import script from "./DisplaySubMenu2.vue?vue&type=script&lang=js&"
export * from "./DisplaySubMenu2.vue?vue&type=script&lang=js&"
import style0 from "./DisplaySubMenu2.vue?vue&type=style&index=0&id=f1fc769a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1fc769a",
  null
  
)

component.options.__file = "DisplaySubMenu2.vue"
export default component.exports